import React from 'react';
import classNames from 'classnames';

interface SliderProps {
  state: boolean;
  handleToggle: () => void;
  className?: string;
}

export default function Toggle({ state, handleToggle, className = '' }: SliderProps): JSX.Element {
  const onChange = (): void => {
    handleToggle();
  };
  return (
    <div
      data-testid="slider"
      className={classNames(
        'relative mr-2 flex h-5 w-10 cursor-pointer items-center rounded-full p-0.5 transition-all duration-500',
        {
          'bg-primary-300': state,
          'bg-secondary-200': !state,
        },
        className,
      )}
      onClick={(): void => onChange()}>
      <span
        className={classNames('h-4 w-4 rounded-full bg-secondary-50 transition-all duration-200', {
          'ml-5': state,
        })}
      />
    </div>
  );
}
